import { useRoutes } from "react-router-dom";
import { Navigate } from "react-router-dom";
// routes
import MainRoutes from "./MainRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";
// import LoginRoutes from "./LoginRoutes";
import config from "../config";
import CustomRoutes from "./CustomRoutes";
import CustomerPortalRoutes from "./CustomerPortalRoutes";
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  // return useRoutes([{ path: "/", element: <Navigate to={config.defaultPath} /> }, AuthenticationRoutes, LoginRoutes, MainRoutes], config.basename);
  const rootApp = String(process.env.REACT_APP_ROOT_APP || "salon").toLowerCase();
  const customerOnly = rootApp === "customer";
  const customerPortalLogin = "/customer-portal/login";
  const routes = customerOnly ? [
    { path: config.basePath + "/", element: <Navigate to={customerPortalLogin} replace /> },
    CustomerPortalRoutes,
    { path: "*", element: <Navigate to={customerPortalLogin} replace /> },
  ] : [
    { path: config.basePath + "/", element: <Navigate to={config.defaultPath} /> },
    CustomerPortalRoutes,
    CustomRoutes,
    AuthenticationRoutes,
    MainRoutes,
  ];
  return useRoutes(routes);
  // return useRoutes([{ path: "/", element: <Navigate to={config.defaultPath} /> }, AuthenticationRoutes], config.basename);
}
